export const AXIOM = {
  nav: {
    logo: 'nav-logo',
    contactBtn: 'nav-contact-btn',
    linkAbout: 'nav-link-about',
    linkServices: 'nav-link-services',
    linkTeam: 'nav-link-team',
    linkProcess: 'nav-link-process',
  },
  hero: {
    root: 'hero-section',
    heading: 'hero-heading',
    subheading: 'hero-subheading',
    ctaPrimary: 'hero-cta-primary',
    ctaSecondary: 'hero-cta-secondary',
  },
  marquee: 'marquee-band',
  manifesto: 'manifesto-section',
  services: {
    root: 'services-section',
    item: (k) => `service-item-${k}`,
  },
  process: 'process-section',
  industries: 'industries-section',
  team: {
    root: 'team-section',
    member: (k) => `team-member-${k}`,
  },
  stats: 'stats-section',
  whyus: 'whyus-section',
  contact: {
    root: 'contact-section',
    form: 'contact-form',
    name: 'contact-input-name',
    email: 'contact-input-email',
    company: 'contact-input-company',
    subject: 'contact-input-subject',
    message: 'contact-input-message',
    submit: 'contact-submit',
    status: 'contact-status',
  },
  footer: 'site-footer',
};
